import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

// Good
const get = function ($, StaffId = null, filters = {}) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/business/${StaffId ? "vehicle/" + StaffId : "" + "vehicle"}`,  { params: filters })
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}


const create = function ($, vehicle) {
  return new Promise((resolve, reject) => {
    HTTP.post(`business/vehicle`, vehicle)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const toggleBlock = function ($, vehicleId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`business/vehicle/${vehicleId}/block-toggle`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getBadge = function ($, vehicleId, version = "v1") {
  return new Promise((resolve, reject) => {
    const params = version ? `?version=${encodeURIComponent(version)}` : "";
    const url = `${BACKEND_API_URL}/business/vehicle/${vehicleId}/badge${params}`;

    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key);
    xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName);
    xhr.responseType = "blob";

    xhr.onload = function () {
      if (xhr.status === 200) {
        const blobUrl = URL.createObjectURL(xhr.response);
        resolve(blobUrl);
      } else {
        reject(xhr);
      }
    };

    xhr.onerror = function () {
      reject(xhr);
    };

    xhr.send();
  });
};

// const getBadge = function ($, vehicleId) {
//   return new Promise((resolve, reject) => {
//     const url = `${BACKEND_API_URL}/business/vehicle/${vehicleId}/badge`;

//     const xhr = new XMLHttpRequest();
//     xhr.open("GET", url, true);
//     xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key);
//     xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName);
//     xhr.responseType = "blob";

//     xhr.onload = function () {
//       if (xhr.status === 200) {
//         const blobUrl = URL.createObjectURL(xhr.response);
//         resolve(blobUrl);
//       } else {
//         reject(xhr);
//       }
//     };

//     xhr.onerror = function () {
//       reject(xhr);
//     };

//     xhr.send();
//   });
// }


const update = function ($, vehicleId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/business/vehicle/${vehicleId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, vehicleId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/business/vehicle/${vehicleId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const close = function ($, vehicleId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/vehicle/${vehicleId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const approveDepartmentChange = function ($, requestId, payload = {}) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/vehicles/department-changes/${requestId}/decision`, {
        action: "approve",
        ...payload,
      })
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  }

const handleFileImport = function ($, file) {
  const formData = new FormData();
  formData.append("file", file);

  HTTP.post("/business/vehicle/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
    .then(() => {
      $.$store.commit("app/message", {
        msg: $.$t("messages.success.import"),
        color: "success"
      });
    })
    .catch((error) => {
      let message = ""
      if (error.response && error.response.data) {
        for (const key in error.response.data) {
          message += `- ${key} : ${error.response.data[key]}\n`
        }
      } else {
        message = "Erreur lors de l'importation"
      }

      $.$store.commit("app/message", {
        msg: message,
        color: "error"
      });
    });
}

/**
 * Historique KMH d'un véhicule
 * Backend attendu: GET /activity/vehicles/:id/kmh-history/?limit=100
 * Réponse: { vehicle_id, current_kmh, results: [{ kmh, created_at, transaction_number, location }, ...] }
 * Adapte le chemin si ton routeur diffère.
 */
const getKmhHistory = function ($, vehicleId, params = {}) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/activity/vehicles/${vehicleId}/kmh-history/`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
  })
}

const resolve = function ($, query) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/business/vehicle/resolve`, { params: { query } })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
  })
}

const exportBadgesZip = function ($, params = {}) {
  return new Promise((resolve, reject) => {
    const qs = new URLSearchParams(params).toString();
    const url = `${BACKEND_API_URL}/business/vehicles/badges/export${qs ? `?${qs}` : ""}`;

    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key);
    xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName);
    xhr.responseType = "blob";

    xhr.onload = function () {
      if (xhr.status === 200) resolve(xhr.response);
      else reject(xhr);
    };
    xhr.onerror = function () { reject(xhr); };
    xhr.send();
  });
};


export default {
  get,
  resolve,
  create,
  update,
  remove,
  close,
  getBadge,
  toggleBlock,
  handleFileImport,
  getKmhHistory,
  approveDepartmentChange,
  exportBadgesZip
}
